import { FLOW_STATES, STATUS_MESSAGES } from '@/constants';

export const getStatusIcon = (currentStep: string) => {
  const completedStates = [
    FLOW_STATES.COMPLETED, 
    FLOW_STATES.BUSINESS_ONBOARDING_COMPLETED
  ];
  
  const warningStates = [
    FLOW_STATES.POPUP_CLOSED, 
    FLOW_STATES.TIMEOUT, 
    FLOW_STATES.CANCELLED_BY_USER
  ];
  
  const errorStates = [
    FLOW_STATES.ERROR, 
    FLOW_STATES.AUTHENTICATION_FAILED, 
    FLOW_STATES.SDK_UNAVAILABLE, 
    FLOW_STATES.LAUNCH_FAILED
  ];

  if (completedStates.includes(currentStep as any)) {
    return 'check';
  } else if (warningStates.includes(currentStep as any)) {
    return 'alert-triangle';
  } else if (errorStates.includes(currentStep as any)) {
    return 'x';
  } else {
    return 'activity';
  }
};

export const getStatusMessage = (currentStep: string): string => {
  return STATUS_MESSAGES[currentStep as keyof typeof STATUS_MESSAGES] || `Estado: ${currentStep}`;
};

export const getStatusColor = (currentStep: string): string => {
  const completedStates = [
    FLOW_STATES.COMPLETED, 
    FLOW_STATES.BUSINESS_ONBOARDING_COMPLETED
  ];
  
  const warningStates = [
    FLOW_STATES.POPUP_CLOSED, 
    FLOW_STATES.TIMEOUT, 
    FLOW_STATES.CANCELLED_BY_USER
  ];
  
  const errorStates = [
    FLOW_STATES.ERROR, 
    FLOW_STATES.AUTHENTICATION_FAILED, 
    FLOW_STATES.SDK_UNAVAILABLE, 
    FLOW_STATES.LAUNCH_FAILED
  ];

  if (completedStates.includes(currentStep as any)) {
    return 'bg-green-100 text-green-800';
  } else if (warningStates.includes(currentStep as any)) {
    return 'bg-orange-100 text-orange-800';
  } else if (errorStates.includes(currentStep as any)) {
    return 'bg-red-100 text-red-800';
  } else {
    return 'bg-blue-100 text-blue-800';
  }
};

export const getCategoryColor = (category: string): string => {
  switch (category) {
    case 'UTILITY':
      return 'bg-blue-100 text-blue-800';
    case 'MARKETING':
      return 'bg-purple-100 text-purple-800';
    case 'AUTHENTICATION':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getLogColor = (level: 'info' | 'warn' | 'error'): string => {
  switch (level) {
    case 'info':
      return 'text-blue-700 bg-blue-50';
    case 'warn':
      return 'text-orange-700 bg-orange-50';
    case 'error':
      return 'text-red-700 bg-red-50';
  }
};

export const formatTimestamp = (timestamp: Date): string => {
  return timestamp.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
};

export const formatPhoneNumber = (phone: string): string => {
  // Basic phone number formatting
  if (!phone) return '';
  
  // Remove any non-digit characters except +
  const cleaned = phone.replace(/[^\d+]/g, '');
  
  // If doesn't start with +, assume it needs country code
  if (!cleaned.startsWith('+')) {
    return `+${cleaned}`;
  }
  
  return cleaned;
};

export const truncateString = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength) + '...';
};